'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var TextParts = require('../common/TextParts');
var styleHelper = require('../../helper/styleHelper');
var _ = require('underscore');

/**
 * 垂直花括号
 */
var VCurly = React.createClass({

  componentWillUnmount: function () {
    if (this.requestID) {
      cancelAnimationFrame(this.requestID);
    }
  },

  _doPaint: function () {
    var canvasDom = ReactDOM.findDOMNode(this.refs.canvas);
    var graphics = canvasDom.getContext('2d');
    var clientWidth = canvasDom.clientWidth;
    var clientHeight = canvasDom.clientHeight;
    var c = clientHeight / 2;
    var ct = c - 7;
    var cb = c + 7;
    var lineWidth = 1;
    var offset = lineWidth / 2;

    this.requestID = window.requestAnimationFrame(function () {
      graphics.clearRect(0, 0, clientWidth, clientHeight);

      graphics.lineWidth = lineWidth;
      graphics.strokeWidth = lineWidth;
      graphics.strokeStyle = styleHelper.getBackgroundColor(this.props);
      if (this.isDirLeft) {


        graphics.moveTo(offset, offset);
        graphics.arcTo(6 - offset, offset, 6 - offset, 5 - offset, 5);

        graphics.lineTo(6 - offset, ct);
        graphics.lineTo(this.curlyWidth, c);
        graphics.lineTo(6 - offset, cb);

        graphics.lineTo(6 - offset, clientHeight - 5);
        graphics.arcTo(6 - offset, clientHeight - offset, offset, clientHeight - offset, 5);

      } else {

        graphics.moveTo(clientWidth - offset, offset);
        //graphics.lineTo(clientWidth - 6, 5);
        graphics.arcTo(clientWidth - 6 + offset,offset,clientWidth - 6 + offset, 5 - offset,5);

        graphics.lineTo(clientWidth - 6 + offset, ct);
        graphics.lineTo(clientWidth - this.curlyWidth, c);
        graphics.lineTo(clientWidth - 6 + offset, cb);

        graphics.lineTo(clientWidth - 6 + offset, clientHeight - 5);
        //graphics.lineTo(clientWidth - 1, clientHeight - 1);
        graphics.arcTo(clientWidth - 6 + offset,clientHeight - offset,clientWidth - offset,clientHeight - offset,5);
      }

      graphics.stroke();

    }.bind(this));

  },

  componentDidUpdate: function () {

    // TODO: 此次出调用绘制时，会导致整体花括号颜色变深，比较奇怪？？？
    this._doPaint();
  },

  componentDidMount: function () {
    this._doPaint();
  },

  render: function () {
    var curlyWidth = 15;
    this.curlyWidth = 15;
    var canvasLeft;
    var dirLeft = this.props.direction == appTypes.VCurlyDirection.LEFT;
    this.isDirLeft = dirLeft;

    var canvasStyle;
    var textStyle;
    var selfW = styleHelper.getWidth(this.props);
    var tprops = _.extend({},this.props);
    tprops.w = styleHelper.getWidth(this.props) - curlyWidth - 3;
    delete tprops.currentW;
    var w = styleHelper.getWidth(tprops);
    var h = styleHelper.getHeight(tprops);
    if (dirLeft) {
      canvasLeft = 0;
    } else {
      canvasLeft = selfW - curlyWidth;
    }

    canvasStyle = {
      left: canvasLeft,
      zIndex:0
    };

    textStyle = {
      left: dirLeft ? curlyWidth + 3 : 0,
      top: 0,
      width: w,
      height: '100%',
      position: 'absolute',
      zIndex:1
    };


    return (<div className="component-Base">
      <canvas ref='canvas'
              style={canvasStyle}
              width={curlyWidth}
              height={h}
      />

      <TextParts {...tprops}
        partStyle={textStyle}
        textVAlign={appTypes.VertAlign.MIDDLE}
        textAlign={dirLeft ? appTypes.HoriAlign.LEFT : appTypes.HoriAlign.RIGHT}
      />

    </div>);
  }
});

module.exports = VCurly;



// WEBPACK FOOTER //
// ./src/views/Components/VCurly.jsx